interface StatusBadgeProps {
  label: string;
  tone?: 'success' | 'warning' | 'danger' | 'neutral';
}

/**
 * Badge com efeito GLOW (referência FTMO "Em andamento") — aura difusa em
 * volta + leve pulse de opacidade. Usado pra status críticos na conta.
 */
export function StatusBadge({ label, tone = 'success' }: StatusBadgeProps) {
  const config = {
    success: {
      bg: 'bg-success-500/[0.08]',
      text: 'text-success-300',
      ring: 'ring-success-500',
      glow: 'shadow-[0_0_12px_3px_rgba(0,201,167,0.5)]',
      dot: 'bg-success-500',
    },
    warning: {
      bg: 'bg-warning-500/15',
      text: 'text-warning-300',
      ring: 'ring-warning-500/40',
      glow: 'shadow-[0_0_24px_rgba(245,197,24,0.55),0_0_8px_rgba(245,197,24,0.4)]',
      dot: 'bg-warning-500',
    },
    danger: {
      bg: 'bg-danger-500/15',
      text: 'text-danger-300',
      ring: 'ring-danger-500/40',
      glow: 'shadow-[0_0_24px_rgba(232,64,64,0.55),0_0_8px_rgba(232,64,64,0.4)]',
      dot: 'bg-danger-500',
    },
    neutral: {
      bg: 'bg-ink-700',
      text: 'text-ink-200',
      ring: 'ring-ink-600/40',
      glow: '',
      dot: 'bg-ink-400',
    },
  }[tone];

  return (
    <span
      className={
        'inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs font-semibold ring-1 ' +
        config.bg +
        ' ' +
        config.text +
        ' ' +
        config.ring +
        ' ' +
        config.glow
      }
    >
      <span className={'h-1.5 w-1.5 animate-pulse rounded-full ' + config.dot} />
      {label}
    </span>
  );
}
